import { NavLink } from 'react-router-dom';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import { styled, Typography } from '@mui/material';
import Box from '@mui/material/Box';

import { colors, zIndex } from '../../styles';

export const MobileHeaderLink = styled(NavLink)`
  text-decoration: none;
  text-transform: capitalize !important;
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  color: ${colors.textSecondary};
  display: inline-block;

  &:hover {
    color: ${colors.textPrimary};
  }

  &.active {
    color: ${colors.blue};
    font-weight: 700;
  }
`;

export const MobileHeaderLinkWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 28px;
  margin-bottom: 28px;
`;

export const MobileHeaderTopLevelLink = styled(MobileHeaderLink)`
  font-weight: 500;
  color: ${colors.textPrimary};
  padding: 28px 0;
  font-size: 18px;
  line-height: 22px;
`;

export const Divider = styled(Box)`
  border-top: 1px solid ${colors.gray};
`;

export const MobileNavigation = styled(Box)`
  display: flex;
  background: white;
  flex-direction: column;
  overflow: auto;
  height: 100%;
  padding: 0 16px;
  max-width: 600px;
  margin: 0 auto;
`;

export const MobileNavigationOuter = styled(Box)`
  height: 100%;
  padding: 82px 0;
  background-color: ${colors.white};
`;

export const MobileHeaderContainer = styled(Box)`
  width: 100%;
  position: fixed;
  top: 0;
  z-index: ${zIndex.header};
  max-height: 100%;
`;

export const Container = styled(Box)<{ isNavOpen: boolean }>`
  background: white;
  display: flex;
  justify-content: space-between;
  padding: 20px 16px;
  position: ${({ isNavOpen }) => (isNavOpen ? 'fixed' : 'static')};
  width: 100%;
`;

export const MenuButton = styled(IconButton)`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  width: 42px;
  height: 42px;
  padding: 8px;
  border: none;
  background: none;

  img {
    color: ${colors.textPrimary};
    width: 100%;
  }
`;

export const LogoLink = styled(NavLink)`
  display: flex;
  background: ${colors.textPrimary};
  padding: 10px;
  box-sizing: border-box;
  height: 42px;
  border-radius: 8px;

  img {
    height: 22px;
  }
`;

export const ContactUsButton = styled(Button)`
  text-transform: none;
  font-size: 16px;
  height: 50px;
  min-width: 120px;
  font-weight: 700;
  padding: 16px 14px;
  line-height: 140%;
`;

export const HeaderLinkGroupTitle = styled(Typography)<{ isOpen?: boolean }>`
  padding: 28px 0;
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  color: ${colors.textPrimary};
  display: flex;
  align-items: center;
  justify-content: space-between;

  img {
    transition: transform 0.3s ease;
    transform: ${({ isOpen }) => (isOpen ? 'rotate(270deg)' : 'rotate(90deg)')};
  }
`;
